module.exports = __webpack_public_path__ + "img/logo.d1a20d47.png";